const types = {
    TEXT_TO_SPEECH_HAS_VALID_SELECTION: 'TEXT_TO_SPEECH_HAS_VALID_SELECTION',
    TEXT_TO_SPEECH_IS_ENABLED: 'TEXT_TO_SPEECH_IS_ENABLED',
    TEXT_TO_SPEECH_IS_PLAYING: 'TEXT_TO_SPEECH_IS_PLAYING',
    TEXT_TO_SPEECH_IS_AUDIO_LOADED: 'TEXT_TO_SPEECH_IS_AUDIO_LOADED',
};

const textToSpeechActions = {
    types,
    setHasValidSelection(value) {
        if (typeof value === 'boolean') {
            return { type: types.TEXT_TO_SPEECH_HAS_VALID_SELECTION, value };
        }
        throw new Error('Non boolean passed to setHasValidSelection().');
    },
    setTextToSpeechIsEnabled(value) {
        if (typeof value === 'boolean') {
            return { type: types.TEXT_TO_SPEECH_IS_ENABLED, value };
        }
        throw new Error('Non boolean passed to setTextToSpeechIsEnabled().');
    },
    setTextToSpeechIsPlaying(value) {
        if (typeof value === 'boolean') {
            return { type: types.TEXT_TO_SPEECH_IS_PLAYING, value };
        }
        throw new Error('Non boolean passed to setTextToSpeechIsPlaying().');
    },
    setIsAudioLoaded(value) {
        if (typeof value === 'boolean') {
            return { type: types.TEXT_TO_SPEECH_IS_AUDIO_LOADED, value };
        }
        throw new Error('Non boolean passed to setIsAudioLoaded().');
    },
};

export default textToSpeechActions;
